<template>
  <div class="platform-checkbox">
    <rich-checkbox-group v-model="platform['type']">
      <div v-for="(itm, index) in options" :key="index">
        <rich-checkbox :option="itm" shape="square">{{itm.label}}</rich-checkbox>
        <div class="platform-checkbox-ext" v-if="platform['type'].includes(itm.value)">
          <div class="platform-checkbox-ext-content" v-for="(linkItm, i) in linkOption" :key="i">
            <span class="sales-text">{{linkItm.label}}</span>
            <component
              :is="linkType"
              v-bind="linkProps"
              v-model="platform[`${itm.value}${linkItm.prop}`]"
              ></component>
            <!-- <rich-stepper
              is-integer
              min= 0
              v-model="platform[`${itm.value}${linkItm.prop}`]"></rich-stepper> -->
          </div>
        </div>
      </div>
    </rich-checkbox-group>
  </div>
</template>
<script>
import { COMPETITORS_PLATFORM_LIST } from '@/config/busiInfo/enums'

export default {
  name: 'platformCheckbox',
  props: {
    value: {
      type: Object,
      default: () => {

      }
    },
    options: {
      type: Array,
      default: () => []
    },
    linkOption: {
      type: Array,
      default: () => []
    },
    linkProps: {
      type: Object,
      default: () => {}
    },
    linkType: {
      type: String,
      default: 'rich-stepper'
    }
  },
  data () {
    return {
      platform: {
        type: []
        // cashPayment: [],
        // onlinePayment: []
      },
      checkList: [],
      // options: COMPETITORS_PLATFORM_LIST,
      inputValue: ''
    }
  },
  mounted () {
    this.platform = Object.assign({}, this.platform, this.value)
  },
  watch: {
    platform: {
      deep: true,
      handler (nVal) {
        nVal = this.formated(nVal)
        console.log(nVal)
        this.$emit('input', nVal)
      }
    }
  },
  methods: {
    formated (data) {
      this.options.forEach(itm => {
        // 特殊处理
        if (!data['type'].includes(itm.value)) {
          if (data[`${itm.value}Sales`] || data[`${itm.value}Rate`]) {
            data[`${itm.value}Sales`] = ''
            data[`${itm.value}Rate`] = ''
          }
          if (data[`${itm.value}Payment`] && data[`${itm.value}Payment`].length > 0) {
            data[`${itm.value}Payment`] = []
          }
        }
      })
      return data
    }
  }
}
</script>
<style lang="scss">
.platform-checkbox {
    .platform-checkbox-ext {
        display: flex;
        flex-direction: column;
        margin: 10px 0;
      &-content {
        display: flex;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .rate-text {
      margin-left: 20px;
    }
}

</style>
